module.exports = __webpack_public_path__ + "img/2.e7aab80d.webp";